import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';
import { Link } from "gatsby";
import StartProjectWithUs from '../components/Common/StartProjectWithUs';

import CSPServicesImg1 from '../assets/images/manufacturing-ai/1.png'
import CSPServicesImg2 from '../assets/images/manufacturing-ai/2.png'
import CSPServicesImg3 from '../assets/images/manufacturing-ai/3.png'
import CSPServicesImg4 from '../assets/images/manufacturing-ai/4.png'
import CSPServicesImg5 from '../assets/images/manufacturing-ai/5.png'


const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Manufacturing AI" description="Improve efficiency and drive profitability with AI-powered solutions.Artificial intelligence is revolutionizing the manufacturing industry. With AI, businesses can improve efficiency, reduce costs, and drive profitability. By incorporating AI into their operations, manufacturers can improve their competitive advantage and stay ahead of the curve in an increasingly complex and rapidly changing industry. "/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Manufacturing AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        <div className="overview-content">
                            <div className="content">
                            <span className="sub-title">AI-DRIVEN MANUFACTURING EXCELLENCE</span>
                                <h2>Improve efficiency and drive profitability with AI-powered solutions</h2>
                                <p>Artificial intelligence is revolutionizing the manufacturing industry. By incorporating AI into their operations, manufacturers can improve their competitive advantage and stay ahead of the curve in an increasingly complex and rapidly changing industry. Don't miss out on the opportunity to leverage AI in your manufacturing business.</p>
                                <div className="features-text">
                                <h4>AI-enabled manufacturing processes can increase productivity by up to 40%, lower costs by up to 50%, and improve quality by up to 70%.</h4>
                                </div>
                                
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CSPServicesImg1} alt="Cimplify Manufacturing AI" />
                            </div>
                        </div>
                    </div>
                    <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">DRIVE MANUFACTURING EXCELLENCE</span>
                        <h2>Core Solutions</h2>
                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                    </div>

                    <div className="row d-flex justify-content-center text-center">
                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/manufacturing-ai#product-inspection">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-search-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Product Inspection</h3>
                                <p> Drive accuracy and efficiency in product quality control with computer vision. </p>
                            </div>
                        </Link>    
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/manufacturing-ai#safety-and-compliance">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-street-view"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Safety & Compliance</h3>
                                <p>Leverage computer vision to keep your manufacturing operations safe and secure.</p>
                            </div>
                            </Link>      
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center text-center">

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/manufacturing-ai#demand-forecasting">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-bar-chart-alt-2"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Demand Forecasting</h3>
                                <p>Unlock the power of machine learning to maximize efficiency and reduce costs with demand forecasting.</p>
                            </div>
                        </Link>    
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/manufacturing-ai#accounting-automation">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-file"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Accounting Automation</h3>
                                <p>Streamline and improve the entire accounting workflow with machine learning and automation.</p>
                            </div>
                        </Link>    
                        </div>

        
                    </div>
                </div>
            </div>
                    <div id="product-inspection" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CSPServicesImg2} alt="Cimplify Product Inspection" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">AI-POWERED QUALITY CONTROL</span>
                                <h2>Product Inspection</h2>
                                <p>Computer vision is revolutionizing quality control in manufacturing. Enjoy precision and efficiency in quality assurance with automated, real-time inspections, faster throughput, and improved accuracy. Unlock the potential of computer vision today!</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Product Defect Detection</span></li>
                                    <li><span><i className='bx bx-check'></i> Missing Component Identification </span></li>
                                    <li><span><i className='bx bx-check'></i> Non-conformance flagging</span></li>
                                    <li><span><i className='bx bx-check'></i> Process Quality Analysis</span></li>
                                    <li><span><i className='bx bx-check'></i> Part Identification</span></li>
                                
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="safety-and-compliance" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">SEE THE UNSEEN</span>
                                <h2>Safety & Compliance</h2>
                                <p>Computer vision is the way forward for safety in manufacturing. With its powerful imaging capabilities, it helps identify potential hazards and errors before they become a problem. Invest in computer vision and ensure your factory is a safe and efficient workplace.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Monitor Workers for Safety Compliance</span></li>
                                    <li><span><i className='bx bx-check'></i> Indentify Potential Hazards on Shopfloor</span></li>
                                    <li><span><i className='bx bx-check'></i> Automated Warnings & Alarms </span></li>
                                    <li><span><i className='bx bx-check'></i> Monthly Reports for Supervisor </span></li>
                                
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CSPServicesImg3} alt="Cimplify Safety & Compliance" />
                            </div>
                        </div>
                    </div>
                    <div id="demand-forecasting" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CSPServicesImg4} alt="Cimplify Demand Forecasting" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">SMARTER PLANNING WITH AI</span>
                                <h2>Demand Forecasting</h2>
                                <p> Leverage Machine Learning to create advanced demand forecasting models and gain insights into your business. With ML, you can accurately predict customer demand and maximize efficiency. Unlock the power of predictive analytics to stay ahead of the competition!</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Production Planning & Scheduling</span></li>
                                    <li><span><i className='bx bx-check'></i> Inventory Management </span></li>
                                    <li><span><i className='bx bx-check'></i> Pricing Optimization </span></li>
                                    <li><span><i className='bx bx-check'></i> Supply Chain Management </span></li>
                                    <li><span><i className='bx bx-check'></i> Maintenance & Repair Planning </span></li>
                            
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="accounting-automation" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">DRIVE EFFICIENCY AND PRODUCTIVITY</span>
                                <h2>Accounting Automation</h2>
                                <p>Machine Learning can be used to automate business processes, making them more efficient and cost-effective. AI can be used to automate mundane and repetitive tasks, such as stock entry, invoice processing and order processing. </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Automate Accounts Payable</span></li>
                                    <li><span><i className='bx bx-check'></i> 1-Click Invoice Digitisation </span></li>
                                    <li><span><i className='bx bx-check'></i> Automate Order Processing </span></li>
                                    <li><span><i className='bx bx-check'></i> Streamline Stock Ledger Management </span></li>
                                    <li><span><i className='bx bx-check'></i> Simplify GST Compliance </span></li>

 
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CSPServicesImg5} alt="Cimplify Accounting Automation" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          



            

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;